import { render } from "./ExploreDecideInvest.vue?vue&type=template&id=9b6750ba&scoped=true"
import script from "./ExploreDecideInvest.vue?vue&type=script&lang=js"
export * from "./ExploreDecideInvest.vue?vue&type=script&lang=js"

import "./ExploreDecideInvest.vue?vue&type=style&index=0&id=9b6750ba&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b6750ba"]])

export default __exports__